(function () {
  'use strict';
  // Clean URLs render Paper by default; only an alternate design on the same URL adds ?view= (aliases may only move the path).
  function previewHref(href, options) {
    if (typeof href !== 'string' || !href || href[0] === '#') return href;
    if (!options || !options.views) return href;
    let url;
    try { url = new URL(href, options.origin); } catch (_) { return href; }
    if (url.origin !== options.origin || !/^https?:$/.test(url.protocol) || url.searchParams.has('view')) return href;
    let path = url.pathname;
    const root = String(options.root || '/').replace(/\/+$/, '');
    if (root) {
      if (path !== root && !path.startsWith(root + '/')) return href;
      path = path.slice(root.length) || '/';
    }
    const alias = options.aliases?.[path];
    let aliasView;
    if (alias && /^\/(?!\/)[a-z0-9/-]+$/.test(alias.path) && (alias.view === undefined || /^dirt-paper-[a-z-]+$/.test(alias.view))) {
      const hashAt = href.indexOf('#'), beforeHash = hashAt < 0 ? href : href.slice(0, hashAt), queryAt = beforeHash.indexOf('?');
      const prefix = /^https?:\/\//.test(href) ? url.origin : href.startsWith('//') ? '//' + url.host : '';
      href = prefix + root + alias.path + (queryAt < 0 ? '' : beforeHash.slice(queryAt)) + (hashAt < 0 ? '' : href.slice(hashAt));
      path = alias.path;
      aliasView = alias.view;
    }
    const view = aliasView || options.views[path];
    if (typeof view !== 'string' || !/^dirt-paper-[a-z-]+$/.test(view)) return href;
    const hash = href.indexOf('#');
    const base = hash < 0 ? href : href.slice(0, hash);
    return base + (base.includes('?') ? (base.endsWith('?') || base.endsWith('&') ? '' : '&') : '?') + 'view=' + view + (hash < 0 ? '' : href.slice(hash));
  }
  if (typeof module === 'object' && module.exports) module.exports.previewHref = previewHref;
  if (typeof window === 'undefined') return;
  const paper = window.DirtPaper || (window.DirtPaper = {});
  if (paper.previewNavigation) return;
  const data = document.querySelector('[data-dirt-preview-views]');
  if (!data) return;
  let views;
  try { views = JSON.parse(data.textContent); } catch (_) { return; }
  let aliases = {};
  try { aliases = JSON.parse(document.querySelector('[data-dirt-preview-aliases]')?.textContent || '{}'); } catch (_) { return; }
  const options = { origin: window.location.origin, root: paper.routes?.root || '/', views, aliases };
  const rewrite = anchor => {
    const before = anchor.getAttribute('href');
    const after = previewHref(before, options);
    if (after !== before) anchor.setAttribute('href', after);
  };
  const scan = node => {
    if (node.nodeType !== 1 && node.nodeType !== 9) return;
    if (node.matches?.('a[href]')) rewrite(node);
    node.querySelectorAll?.('a[href]').forEach(rewrite);
  };
  scan(document);
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') rewrite(record.target);
      else record.addedNodes.forEach(scan);
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  paper.previewHref = href => previewHref(href, options);
  paper.previewNavigation = { dispose() { observer.disconnect(); delete paper.previewNavigation; } };
  window.addEventListener('pagehide', event => { if (!event.persisted) paper.previewNavigation?.dispose(); });
})();
